import React, { useState } from 'react';
import times from 'lodash/times';
import { useIsMutating } from 'react-query';
import { useSuggestions } from './useSuggestions';
import { SuggestionsHeader } from '../components/SuggestionsHeader/SuggestionsHeader';
import { TaskItem } from '../components/TaskItem/TaskItem';
import { TaskItemLoading } from '../components/TaskItem/TaskItem.loading';
import { MAX_TASKS } from '../Tasks.constants';
import { useIsCurrentPlanSelected } from '../../../hooks/useIsCurrentPlanSelected';
import { EmptyList } from '../components/EmptyList/EmptyList';
import { TaskItemFooter } from '../components/TaskItemFooter/TaskItemFooter';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { RESET_ACTION_STEPS_MK } from '../api/useResetActionStepMutation';
import { useIsPdf } from '../../../../hooks/useIsPdf';

interface SuggestionsProps {
  goalId?: string;
  debtType?: number;
}

export const Suggestions = ({ goalId, debtType }: SuggestionsProps) => {
  const { isCurrentPlanSelected } = useIsCurrentPlanSelected();

  if (isCurrentPlanSelected) {
    return null;
  }

  return (
    <Card p="16" height="100%">
      <SuggestionsHeader debtType={debtType} />

      <SuggestionsContent goalId={goalId} />
    </Card>
  );
};

const SuggestionsContent = ({ goalId }: SuggestionsProps) => {
  const isPrint = useIsPdf();
  const { data, isLoading } = useSuggestions(goalId);

  const [showTotalList, setShowTotalList] = useState(isPrint);

  const isResetting = useIsMutating({ mutationKey: RESET_ACTION_STEPS_MK }) > 0;

  if (isLoading || isResetting) {
    return (
      <>
        {times(4).map(i => (
          <TaskItemLoading key={i} icon={i + 2} />
        ))}
      </>
    );
  }

  if (!data) {
    return null;
  }

  if (data.suggestions.length === 0) {
    return <EmptyList />;
  }

  return (
    <>
      {data.suggestions
        .filter((task, index) => showTotalList || index < MAX_TASKS)
        .map(suggestion => (
          <TaskItem
            key={suggestion.Id}
            {...suggestion}
            pulseCheckCategory={data?.goal.PulseCheckCategory}
          />
        ))}

      {data.suggestions.length > MAX_TASKS && !isPrint && (
        <TaskItemFooter setShowTotalList={setShowTotalList} showTotalList={showTotalList} />
      )}
    </>
  );
};
